export enum ReceiveEventsEnum {
  OCR_START = "OCR_START",
  OCR_END = "OCR_END",
  PAYMENT_START = "PAYMENT_START",
  PAYMENT_END = "PAYMENT_END",
  BANKREADER_START = "BANKREADER_START",
  BANKREADER_END = "BANKREADER_END",
  IBAN_SELECTION = "IBAN_SELECTION",
  DECISION_RESULT = "DECISION_RESULT",
  SIGNATURE_START = "SIGNATURE_START",
  SIGNATURE_END = "SIGNATURE_END",
  ACTIVATION = "ACTIVATION",
  DECISION_RED = "DECISION_RED",
  DENEGATION_WTD = "DENEGATION_WTD",
  DENEGATION_TUD = "DENEGATION_TUD",
  WEBSOCKET_INITIALIZATION = "WEBSOCKET_INITIALIZATION",
  WEBSOCKET_DISCONNECTION = "WEBSOCKET_DISCONNECTION",
}

export enum SendEventsEnum {
  START = "ClientStart",
}
